import clsx from "clsx";
import {
  InsurerPicker,
  OfficeButton,
  PDFRenderer,
  RegularSelectInput,
  Show,
  TextInput,
} from "components";
import config from "config";
import { useFormik } from "formik";
import { Info } from "lucide-react";
import { wrapClick } from "utils";
import * as Yup from "yup";

type Props = {};

const initialValues = {
  insurer_id: "",
  from: "",
  doc_type: "",
};

const validationSchema = Yup.object().shape({
  insurer_id: Yup.string().required("Insurer is required"),
  from: Yup.string().required("Reporting date is required"),
  doc_type: Yup.string().required("Document type is required"),
});

const AgingAnalysisSummary = (props: Props) => {
  const form = useFormik<any>({
    initialValues,
    validationSchema,
    onSubmit: () => {
      form.setFormikState((state) => ({ ...state, status: "SUBMITTED" }));
      form.setSubmitting(false);
      return;
    },
  });

  return (
    <div className="w-full">
      <div className="py-3 flex justify-between">
        <div>
          <h1 className="font-bold text-primary text-lg">
            Aging Analysis Summary
          </h1>
        </div>
        <div className="flex items-center space-x-2">
          <OfficeButton
            disabled={form.isSubmitting}
            onClick={wrapClick(form.handleSubmit)}
          >
            {form.isSubmitting ? "Generating ..." : "Generate Report"}
          </OfficeButton>
        </div>
      </div>
      <form className="space-y-6 divide-y shadow-sm rounded-md bg-white p-6 divide-gray-200">
        <div className="bg-red-50 text-red-800 p-3 text-xs rounded my-5 flex justify-start gap-3 items-center">
          <Info className="h-4 w-4" />
          <p>
            Note: Aging analysis will be based on all CLOSED business and
            selected cedants in the system that has remained UNPAID or
            PARTPAYMENT.
          </p>
        </div>
        <div>
          <span className="text-xs font-light">
            Aging Analysis Summary Parameters
          </span>
          <div className="grid grid-cols-2 gap-2">
            <div className="pt-3">
              <InsurerPicker
                id="insurer_id"
                label="Insurer"
                placeholder="e.g. Select Insurer"
                required={true}
                rawId
                {...form}
              />
            </div>
            <div className="">
              <TextInput
                id="from"
                label={"Reporting Date"}
                type="date"
                placeholder=""
                required={true}
                {...form}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-5 my-5">
            <div
              className={clsx({
                "col-span-2": form.values.doc_type?.includes(
                  "Portfolio Statement"
                ),
              })}
            >
              <RegularSelectInput
                id="doc_type"
                label="Document Type"
                placeholder="Select Document Type"
                options={[
                  {
                    label: "Excel",
                    value: "EXCEL",
                  },
                  {
                    label: "PDF",
                    value: "PDF",
                  },
                ]}
                {...form}
              />
            </div>
          </div>
        </div>
      </form>

      <Show if={Boolean(form.status === "SUBMITTED" && form.isValid)}>
        <PDFRenderer
          url={`${config.asset.uri}aging-analysis-report-summary/${btoa(
            JSON.stringify({
              date_of_reporting: form?.values?.from,
              type: form?.values?.doc_type,
              insurer_id: form?.values?.insurer_id,
            })
          )}`}
        />
      </Show>
    </div>
  );
};

export default AgingAnalysisSummary;
